import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import {
  getprojectvehichles,
  saveemployeetoproject,
  saveitem,
  updateItem,
} from "../../utils/firebasefunctions";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";
import { actionType } from "../context/reducer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";
import { HiOutlineArrowDown } from "react-icons/hi2";
import { arrayUnion } from "firebase/firestore";
import userlogo from "../images/user.png";
import { IoIosCloseCircle } from "react-icons/io";
import { IoCheckmarkCircle } from "react-icons/io5";
import { FaCircleMinus } from "react-icons/fa6";
import ProjectPopUp from "../components/ProjectPopUp";
import EmployeePopup from "../components/EmployeePopup";
import { FaDollarSign } from "react-icons/fa";
import Vehicledropdown from "../components/Vehicledropdown";
import { FaCar } from "react-icons/fa";
import { LiaProjectDiagramSolid } from "react-icons/lia";
import { FaUser } from "react-icons/fa";
// import Section2 from '../components/Homesection/section2'
function AddSupervisorToVehicle() {
  const [{ user, employees, clients }, dispatch] = useStateValue();
  const [selectedtype, setselectedtype] = useState("Employee");
  const [vehiclepopup, setvehiclepopup] = useState(false);

  const [vehicles, setvehicles] = useState([]);
  const [selectedemployee, setselectedemployee] = useState([]);
  const [selectedproject, setselectedproject] = useState("");
  const [duedate, setduedate] = useState(new Date());
  const [startdate, setstartdate] = useState(new Date());
  const [employeepopup, setemployeepopup] = useState(false);
  const [selectedvehicle, setselectedvehicle] = useState("");

  const [projectpopup, setprojectpopup] = useState(false);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    projectvehichles();
  }, []);

  const projectvehichles = async () => {
    await getprojectvehichles("vehicles", user.id)
      .then(async (response) => {
        if (response.length > 0) {
          setvehicles(response);
        }
      })
      .catch((err) => {
        alert(err);
      });
  };

  const assignsupervisortovehicle = async () => {
    const assign = employees.filter(
      (x) =>
        x.vehiclesassigned?.find(
          (data) => data == selectedvehicle.id && x.selected,
        ) != undefined,
    );
    if (employees.filter((x) => x.selected).length < 1) {
      toast.warn("Please select a Supervisor to assign to vehicle.");
    } else if (selectedvehicle == "") {
      toast.warn("Please select a vehicle to assign to supervisor.");
    } else if (assign.length > 0) {
      assign.map((item) => {
        toast.warn(
          `${item.firstname} ${item.lastname} is already assigned to ${selectedvehicle.registrationnumber} `,
        );
      });
    } else {
      setloading(true);

      let getemployee = employees.filter((x) => x.selected);

      getemployee.map(async (item, index) => {
        let data = {
          vehiclesassigned: arrayUnion(selectedvehicle.id),
        };
        await updateItem("users", item.id, data)
          .then(async (response) => {
            let dataarray = {
              assignedsupervisors: arrayUnion(item.id),
            };
            await updateItem("vehicles", selectedvehicle.id, dataarray)
              .then(async (response) => {
                let data = [];

                if (item.vehiclesassigned == undefined) {
                  data.push(selectedvehicle.id);
                  item["vehiclesassigned"] = data;
                } else {
                  data = [...item.vehiclesassigned];

                  data.push(selectedvehicle.id);
                  item.vehiclesassigned = data;
                }

                let employeedata = [...employees];
                const employeeindex = employeedata.findIndex(
                  (itemdata) => itemdata.id === item.id,
                );
                employeedata[employeeindex]["vehiclesassigned"] = data;

                dispatch({
                  type: actionType.UPDATEEMPLOYEEDATA,
                  payload: employeedata,
                });

                toast.success(
                  item.firstname +
                    " " +
                    item.lastname +
                    " assigned successfully to " +
                    selectedvehicle.registrationnumber,
                );

                if (index == getemployee.length - 1) {
                  setselectedemployee([]);
                  let employeesdata = [...employees];
                  for (const key in employeesdata) {
                    employeesdata[key].selected = false;
                  }
                  setselectedvehicle("");
                  dispatch({
                    type: actionType.STORE_EMPLOYEES,
                    payload: employeesdata,
                  });

                  setloading(false);
                }
              })
              .catch((err) => {
                alert("updating error " + err);
                setloading(false);
              });
          })
          .catch((err) => {
            toast.warn(err);
            console.log(err);
            setloading(false);
          });
        // }
      });
    }
  };

  const createAssignedVehiclesSet = () => {
    const assignedVehicles = new Set();
    let getemployee = employees.filter((x) => x.selected);

    getemployee.forEach((employee) => {
      employee?.vehiclesassigned?.forEach((assignment) => {
        assignedVehicles.add(assignment);
      });
    });

    return assignedVehicles;
  };

  const assignedVehicles = createAssignedVehiclesSet();

  return (
    <div className="w-[100%]     flex flex-col items-center  mt-[70px] md:mt-[0px] ">
      <p className="text-[22px] text-textcolor PoppinsRegular  self-start pb-[30px]">
        Assign Vehicle
      </p>

      <div className=" flex flex-row w-full   ">
        <button
          onClick={() => {
            setselectedtype("Employee");
          }}
          type="submit"
          className={`text-center py-2 rounded-md text-white ${
            selectedtype == "Employee"
              ? "bg-themeblue hover:bg-themeblue/80  "
              : "bg-themelightblack hover:bg-themelightblack/80 "
          } px-[10px]  text-sm  PoppinsRegular uppercase bg-cardOverlay  drop-shadow-lg`}
        >
          Employee
        </button>
      </div>

      <div className="  bg-themelightblack w-[100%]  px-[20px] py-[30px]   mx-auto  bg-cardOverlay rounded-xl  drop-shadow-lg mt-[10px] ">
        {selectedtype == "Employee" && (
          <>
            <div className="flex flex-col md:flex-row items-center justify-between w-full">
              <div className="w-full md:w-[45%]  ">
                <div className=" w-full flex flex-col items-center ">
                  {employees.filter((x) => x.selected).length > 0 ? (
                    <div className="flex flex-row">
                      {employees
                        .filter((x) => x.selected)
                        .map((item, ind) => {
                          return (
                            <img
                              loading="lazy"
                              style={{
                                marginLeft:
                                  employees.filter((x) => x.selected).length > 1
                                    ? -50
                                    : 0,
                              }}
                              src={
                                item.profilepicture
                                  ? item.profilepicture
                                  : userlogo
                              }
                              className="w-[100px] h-[100px] rounded-full object-cover"
                            />
                          );
                        })}
                    </div>
                  ) : (
                    <div className="w-[100px] h-[100px] rounded-full  flex justify-center items-center bg-themelightblack bg-cardOverlay drop-shadow-lg ">
                      <FaUser className="w-[50px] h-[50px] text-textcolor" />
                    </div>
                  )}
                  <p className="PoppinsRegular text-textcolor text-sm  pb-1 w-full text-left mt-[20px]">
                    Select Supervisor
                  </p>

                  <div className="flex relative  w-full">
                    <div
                      onClick={() => {
                        setemployeepopup(!employeepopup);
                      }}
                      className="px-4 text-textcolor text-sm  PoppinsRegular w-full py-[10px] rounded-md border border-bordercolor items-center flex flex-wrap "
                    >
                      {employees?.length == 0 ||
                      employees.find((data) => data.selected == true) ==
                        undefined
                        ? "Select Supervisor"
                        : employees
                            .filter(function (data) {
                              return data.selected == true;
                            })
                            .map(function (data) {
                              return (
                                <div
                                  onClick={() => {
                                    let dataset = [...employees];
                                    const designationindex = dataset.findIndex(
                                      (item) => item.id === data.id,
                                    );
                                    dataset[designationindex].selected = false;
                                    dispatch({
                                      type: actionType.STORE_EMPLOYEES,
                                      payload: dataset,
                                    });
                                  }}
                                  className="bg-themeColor px-[5px] py-[1px] mr-[5px] rounded-md flex flex-row items-center mb-[2px]"
                                >
                                  <p className="text-white ">
                                    {data.firstname}
                                  </p>
                                  <IoIosCloseCircle
                                    onClick={(id) => {
                                      console.log(id);
                                    }}
                                    className=" text-white ml-[3px]  w-[15px] h-[15px] hover:cursor-pointer"
                                  />
                                </div>
                              );
                            })}
                    </div>
                    <EmployeePopup
                      bulkaction={(status) => {
                        let data = [...employees];
                        // Update the main 'employees' array to mark the selected ones
                        const updatedArray = data.map((item) => ({
                          ...item,
                          selected:
                            item.usertype != "Supervisor" ? false : status,
                        }));
                        dispatch({
                          type: actionType.STORE_EMPLOYEES,
                          payload: updatedArray,
                        });
                        setselectedemployee(
                          updatedArray.filter((obj) => obj.selected),
                        );
                      }}
                      supervisorflow={true}
                      multi={true}
                      visible={employeepopup}
                      data={employees.filter(function (data) {
                        return data.usertype == "Supervisor";
                      })}
                      activateoutsidecontainerclick={() => {
                        setemployeepopup(false);
                      }}
                      onClick={(item, index) => {
                        const employeeindex = employees.findIndex(
                          (itemdata) => item.id === itemdata.id,
                        );

                        let data = [...employees];
                        data[employeeindex].selected =
                          !data[employeeindex].selected;

                        dispatch({
                          type: actionType.STORE_EMPLOYEES,
                          payload: data,
                        });
                        setselectedemployee(data.filter((obj) => obj.selected));
                      }}
                    />
                  </div>
                </div>
              </div>

              {/*
            <HiOutlineArrowDown

className="text-lighttextGray/80 w-[60px] h-[100px] "
/> */}
              <div className="w-full md:w-[45%] mt-[40px] md:mt-[0px] ">
                <div className=" w-full flex flex-col items-center ">
                  {selectedvehicle != "" ? (
                    <div className="flex flex-row">
                      <img
                        loading="lazy"
                        src={
                          selectedvehicle.logo ? selectedvehicle.logo : userlogo
                        }
                        className="w-[100px] h-[100px] rounded-full object-cover"
                      />
                    </div>
                  ) : (
                    <div className="w-[100px] h-[100px] rounded-full bg-themelightblack bg-cardOverlay drop-shadow-lg  flex justify-center items-center">
                      <FaCar className="w-[50px] h-[50px] text-textcolor" />
                    </div>
                  )}
                  <p className="PoppinsRegular text-textcolor text-sm  pb-1 w-full text-left mt-[20px]">
                    Select Vehicle
                  </p>

                  <div className="flex relative  w-full">
                    <div
                      onClick={() => {
                        setvehiclepopup(!vehiclepopup);
                      }}
                      className="px-4 text-textcolor text-sm  PoppinsRegular w-full py-[10px] rounded-md border border-bordercolor items-center flex flex-wrap "
                    >
                      {selectedvehicle == "" ? (
                        "Select Vehicle"
                      ) : (
                        <div
                          onClick={() => {
                            setselectedvehicle("");
                          }}
                          className="bg-themeColor px-[5px] py-[1px] mr-[5px] rounded-md flex flex-row items-center mb-[2px]"
                        >
                          <p className="text-white ">
                            {selectedvehicle.registrationnumber}
                          </p>
                          <IoIosCloseCircle
                            onClick={(id) => {
                              console.log(id);
                            }}
                            className=" text-white ml-[3px]  w-[15px] h-[15px] hover:cursor-pointer"
                          />
                        </div>
                      )}
                    </div>
                    <Vehicledropdown
                      multi={false}
                      visible={vehiclepopup}
                      data={vehicles}
                      activateoutsidecontainerclick={() => {
                        setvehiclepopup(false);
                      }}
                      assignedVehicles={assignedVehicles}
                      onClick={(item, index) => {
                        setselectedvehicle(item);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="py-[20px] w-full">
          {loading ? (
            <div className=" py-4  mt-6 w-full flex justify-center  ">
              <RotatingLines
                visible={true}
                height="25"
                width="25"
                color="grey"
                strokeColor="#00C763"
                strokeWidth="5"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            <button
              onClick={() => {
                if (selectedtype == "Employee") {
                  assignsupervisortovehicle();
                }
              }}
              type="submit"
              className="text-center py-4 rounded-md  bg-themeblue hover:bg-themeblue/80 w-full  mx-auto text-white text-sm  PoppinsRegular uppercase "
            >
              Assign
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddSupervisorToVehicle;
